import { BrowserDetect } from "./utils/BrowserDetect";

export var projectMetadata: Project;

export class LogServer {
    private static readonly ErrorLogServerAdress = `https://error-handling-server.herokuapp.com`
    private static readonly LogObjectServerAdress = `https://server-object-logger.herokuapp.com/api/log`;

    private static readonly serverPostError = `${LogServer.ErrorLogServerAdress}/api/errors`;
    private static readonly serverPostStatistic = `${LogServer.ErrorLogServerAdress}/api/statistic`;

    public static sendStatisticUsage(data?) {
        const browserDetect = BrowserDetect.detect();
        let statisticData;

        if(browserDetect && browserDetect.name) {
            statisticData = {
                browserName : browserDetect.name,
                OS: browserDetect.os
            }
        }

        LogServer.postData(LogServer.serverPostStatistic, {...data, ...statisticData})
    }

    public static sendError(e: ProjectError) {
        e.projectName = e.projectName || projectMetadata.projectName;
        e.projectBuild = e.projectBuild || projectMetadata.projectBuild;

        LogServer.postData(LogServer.serverPostError, e); //.then(() => console.log("Error logged", e))
    }

    public static sendLog(objectToLog: object) {
        LogServer.postData(LogServer.LogObjectServerAdress, objectToLog)
    }

    private static postData(url, data, callback = null) {
        $.ajax({
            type: "POST",
            url: url,
            data: data,
            success: callback,
            dataType: "json"
          });

        // return fetch(url, {
        //     body: JSON.stringify(data),
        //     cache: 'no-cache',
        //     credentials: 'same-origin',
        //     headers: {
        //         'user-agent': window.navigator.userAgent,
        //         'content-type': 'application/json'
        //     },
        //     method: 'POST',
        //     mode: 'cors',
        //     redirect: 'follow',
        //     referrer: 'no-referrer',
        // })
        //     .then(response => response.json())
        //     .catch(err => console.log(err))
    }
}

export interface Project {
    projectName?: string,
    projectBuild?: string
}

export interface ProjectError extends Project {
    error: object,
    additional?: object
}

